// extracted by mini-css-extract-plugin
export default {"emptyState":"EmptyState_emptyState__QYbLl","title":"EmptyState_title__204U3","subtitle":"EmptyState_subtitle__VzFBr","wrapperText":"EmptyState_wrapperText__KvJsz"};